<template>
  <div class="c-loading-overlay">
    <transition name="fade" appear>
      <div v-if="loading" class="c-loading-overlay__overlay">
        <!-- [[ Loading ... ]] -->
      </div>
    </transition>
    <slot :startLoading="startLoading"></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errorOccured: false,
      loading: false
    };
  },
  methods: {
    async startLoading(callback) {
      this.loading = true;
      try {
        await callback();
      } catch (e) {
        this.errorOccured = true;
        setTimeout(() => {
          this.errorOccured = false;
        }, 3000);
        throw e;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.c-loading-overlay {
  position: relative;

  &__overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(#fff, 0.6);
    height: 100%;
    width: 100%;
    z-index: 9999;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
